import React from 'react';
import { useSelector } from 'react-redux';
import { getIsMotorcycleVariationsEnabled } from '@yme/selectors/common';
import { getProductYAMTStatus } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { InformationAlert } from './components';
import { MARINE_ENGINE_ALERT_DATA_TEST_ID, YAMT_TRANSMISSION_ALERT_DATA_TEST_ID, } from './constants';
export function InformationAlerts({ filterTypes, linksAddresses }) {
    const { isMarineEnginesFilter, isMotorcyclesFilter } = filterTypes;
    const { motorcyclesInfoLink, outboardEnginesSelectionLink } = linksAddresses;
    const isYAMTTransmission = useSelector(getProductYAMTStatus);
    const isMotorcycleVariationsEnabled = useSelector(getIsMotorcycleVariationsEnabled);
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        isMarineEnginesFilter && (React.createElement(InformationAlert, { message: t('productCard_needHelpWithConfigurations_message'), link: outboardEnginesSelectionLink, dataTestId: MARINE_ENGINE_ALERT_DATA_TEST_ID })),
        isMotorcyclesFilter && isMotorcycleVariationsEnabled && isYAMTTransmission && (React.createElement(InformationAlert, { message: t('productCard_learnAboutYAMT_message'), link: motorcyclesInfoLink, dataTestId: YAMT_TRANSMISSION_ALERT_DATA_TEST_ID }))));
}
